export const BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL ?? "https://api.idehnama.ir/cp/v1";
  // process.env.NEXT_PUBLIC_BASE_URL ?? "http://localhost:8081/cp/v1";

export const IS_PRODUCTION = process.env.NEXT_PUBLIC_STAGE === "production";


export const ACCESS_TOKEN_EXPIRE_MIN = 60;
export const REFRESH_TOKEN_EXPIRE_HOURS = 24;

export const ACCESS_TOKEN_EXPIRE_DAYS = ACCESS_TOKEN_EXPIRE_MIN / 60 / 24;
export const REFRESH_TOKEN_EXPIRE_DAYS = REFRESH_TOKEN_EXPIRE_HOURS / 24;

export const ACCESS_TOKEN_MAX_AGE_SEC = ACCESS_TOKEN_EXPIRE_MIN * 60;
export const REFRESH_TOKEN_MAX_AGE_SEC = REFRESH_TOKEN_EXPIRE_HOURS * 60 * 60;
